import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-loader',
	templateUrl: './loader.component.html',
	styleUrls: ['./loader.component.scss'],
	host: {
		class: 'main',
	},
})
export class LoaderComponent {
	@Input() title: string = '';
	@Input() subtitle: string = '';
}
